  // Recipe Kit Cart Event Listener
  // - event is dispatched everytime a cart item is added/removed from the recipe card
  // - use below function to update your sidebar/ajax cart number as needed.
  document.addEventListener('rk_cart_event', function (e) {
    // cart variable includes entirety of newly updated Shopify Cart, use accordingly
    var cart = e.detail.cart;
    console.log(cart);
                window.refreshCart(cart);
                if ($('body').hasClass('fancybox-active')) {
                  $.fancybox.close();
                }
                if ($('#header').is(':visible')) {
                  $('#header .cart-container').addClass('active_link');
                } else if ($('.sticky_nav--stick').length) {
                  $('.sticky_nav .cart-container').addClass('active_link');
                } else {
                  $('.top-bar .cart-container').addClass('active_link');
                }
                  // Scroll to the top of the page unless the header is fixed
                    window.scroll({
                      top: 0,
                      left: 0,
                    });
  }, false);

  $(window).scroll(function(){
    if ($(this).scrollTop() > 50) {
       $('header').addClass('scrolled');
    } else {
       $('header').removeClass('scrolled');
    }
  });

  $(document).ready(function() {

   $(window).scroll(function() {
        var scrollDistance = $(window).scrollTop(); 
        var triggerDistance = 100; 

        if (scrollDistance > triggerDistance) {
            $('.main-nav__wrapper').addClass('sticky-desk'); 
            $('.promo-banner').addClass('sticky-desk'); 
            $('#header .top-bar').addClass('sticky-mbl'); 
            $('#free-shipping-message-mbl').addClass('sticky-mbl'); 
          
          
           
        } else {
            $('.main-nav__wrapper').removeClass('sticky-desk'); 
            $('.promo-banner').removeClass('sticky-desk'); 
            $('#header .top-bar').removeClass('sticky-mbl'); 
            $('#free-shipping-message-mbl').removeClass('sticky-mbl'); 
          
          
        }
    });
  
    if ($('.add_to_cart').hasClass('disabled')) {
        $('.add_to_cart').append('<div class="item-added-message">Your item has been added to the cart.</div>');
    }   


  // Function to update the free shipping message
  function updateFreeShippingMessage() {
    $.ajax({
      url: '/cart.js',
      type: 'GET',
      dataType: 'json',
      success: function(cart) {
        var freeShippingThreshold = 150;
        var cartTotal = cart.total_price / 100; // Shopify returns total in cents
        var amountLeft = freeShippingThreshold - cartTotal;

        if (cartTotal >= freeShippingThreshold) {
          $('#free-shipping-message').html(' <img src="https://cdn.shopify.com/s/files/1/0717/2800/5360/files/Flag_of_Canada__Pantone__svg.png?v=1754988370" width="28" height="14" alt="Flag_of_Canada__Pantone" style="max-height:14px;"/> Congrats! You’re getting Free Shipping! <img src="https://cdn.shopify.com/s/files/1/0717/2800/5360/files/Flag_of_Canada__Pantone__svg.png?v=1754988370" width="28" height="14" alt="Flag_of_Canada__Pantone" style="max-height:14px;"/>');
          $('#free-shipping-message-cart').html(' <img src="https://cdn.shopify.com/s/files/1/0717/2800/5360/files/Flag_of_Canada__Pantone__svg.png?v=1754988370" width="28" height="14" alt="Flag_of_Canada__Pantone" style="max-height:14px;"/> Congrats! You’re getting Free Shipping! <img src="https://cdn.shopify.com/s/files/1/0717/2800/5360/files/Flag_of_Canada__Pantone__svg.png?v=1754988370" width="28" height="14" alt="Flag_of_Canada__Pantone" style="max-height:14px;"/>');
          
        } else if (cartTotal > 0) {
          $('#free-shipping-message').html(' <img src="https://cdn.shopify.com/s/files/1/0717/2800/5360/files/Flag_of_Canada__Pantone__svg.png?v=1754988370" width="28" height="14" alt="Flag_of_Canada__Pantone" style="max-height:14px;"/> You are $' + amountLeft.toFixed(2) + ' away from Free Shipping <img src="https://cdn.shopify.com/s/files/1/0717/2800/5360/files/Flag_of_Canada__Pantone__svg.png?v=1754988370" width="28" height="14" alt="Flag_of_Canada__Pantone" style="max-height:14px;"/>');
          $('#free-shipping-message-cart').html(' <img src="https://cdn.shopify.com/s/files/1/0717/2800/5360/files/Flag_of_Canada__Pantone__svg.png?v=1754988370" width="28" height="14" alt="Flag_of_Canada__Pantone" style="max-height:14px;"/> You are $' + amountLeft.toFixed(2) + ' away from Free Shipping <img src="https://cdn.shopify.com/s/files/1/0717/2800/5360/files/Flag_of_Canada__Pantone__svg.png?v=1754988370" width="28" height="14" alt="Flag_of_Canada__Pantone" style="max-height:14px;"/>');
          
        } else {
          $('#free-shipping-message').html(' <img src="https://cdn.shopify.com/s/files/1/0717/2800/5360/files/Flag_of_Canada__Pantone__svg.png?v=1754988370" width="28" height="14" alt="Flag_of_Canada__Pantone" style="max-height:14px;"/> Free Shipping on Orders Over $150 <img src="https://cdn.shopify.com/s/files/1/0717/2800/5360/files/Flag_of_Canada__Pantone__svg.png?v=1754988370" width="28" height="14" alt="Flag_of_Canada__Pantone" style="max-height:14px;"/>');
          $('#free-shipping-message-cart').html(' <img src="https://cdn.shopify.com/s/files/1/0717/2800/5360/files/Flag_of_Canada__Pantone__svg.png?v=1754988370" width="28" height="14" alt="Flag_of_Canada__Pantone" style="max-height:14px;"/> Free Shipping on Orders Over $150 <img src="https://cdn.shopify.com/s/files/1/0717/2800/5360/files/Flag_of_Canada__Pantone__svg.png?v=1754988370" width="28" height="14" alt="Flag_of_Canada__Pantone" style="max-height:14px;"/>');
          
        }
        
        
         if (cartTotal >= freeShippingThreshold) {
          $('#free-shipping-message-mbl').html('<img src="https://cdn.shopify.com/s/files/1/0717/2800/5360/files/Flag_of_Canada__Pantone__svg.png?v=1754988370" width="28" height="14" alt="Flag_of_Canada__Pantone" style="max-height:14px;"/> Congrats! You’re getting Free Shipping! <img src="https://cdn.shopify.com/s/files/1/0717/2800/5360/files/Flag_of_Canada__Pantone__svg.png?v=1754988370" width="28" height="14" alt="Flag_of_Canada__Pantone" style="max-height:14px;"/>');
        } else if (cartTotal > 0) {
          $('#free-shipping-message-mbl').html('<img src="https://cdn.shopify.com/s/files/1/0717/2800/5360/files/Flag_of_Canada__Pantone__svg.png?v=1754988370" width="28" height="14" alt="Flag_of_Canada__Pantone" style="max-height:14px;"/> You are $' + amountLeft.toFixed(2) + ' away from Free Shipping <img src="https://cdn.shopify.com/s/files/1/0717/2800/5360/files/Flag_of_Canada__Pantone__svg.png?v=1754988370" width="28" height="14" alt="Flag_of_Canada__Pantone" style="max-height:14px;"/>');
        } else {
          $('#free-shipping-message-mbl').html('<img src="https://cdn.shopify.com/s/files/1/0717/2800/5360/files/Flag_of_Canada__Pantone__svg.png?v=1754988370" width="28" height="14" alt="Flag_of_Canada__Pantone" style="max-height:14px;"/> Free Shipping on Orders Over $150 <img src="https://cdn.shopify.com/s/files/1/0717/2800/5360/files/Flag_of_Canada__Pantone__svg.png?v=1754988370" width="28" height="14" alt="Flag_of_Canada__Pantone" style="max-height:14px;"/>');
        }
      }
    });
  }

  // Call the function on page load
  updateFreeShippingMessage();

  // Re-call the function whenever the cart is updated
  $(document).on('cart:updated', updateFreeShippingMessage);

  
  function menucroll() {
    var $nav = $(".js-header-sticky");
    $nav.removeClass('menu-destop-scroll');

    $(document).scroll(function() {

        $nav.toggleClass('menu-destop-scroll', $(this).scrollTop() > $nav.height());
    });
  }
  menucroll();

  $('.button-filter-mobile').click(function(){
    $('body').addClass('active-filter');
  });
  $('.close-filter-mobile').click(function(){
    $('body').removeClass('active-filter');
  });
  

});

(() => {
  const header = document.querySelector('[data-header-feature-image="true"]');
  if (header) {
    header.classList.add('feature_image');
  }

  const headerContent = document.querySelector('[data-header-is-absolute="true"]');
  if (header) {
    header.classList.add('is-absolute');
  }
})();

